import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Tracker/services/constants";

export const initTrackerModuleAction = createAction(`${moduleSlug}/initTrackerModuleAction`);
export const initTrackerModuleLoading = createAction(`${moduleSlug}/initTrackerModuleLoading`);